import React from "react";

const Pic = ({ handleChange, answer, isSelected }) => {
  return (
    <div className="poll_pic">
      <div className="the_pic">
        <a
          href={`https://static.netvideogirls.com/polls/${answer.id}.jpg`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={`https://static.netvideogirls.com/polls/${answer.id}-thumb.jpg`}
            alt={answer.answer}
          />
        </a>
      </div>
      <div className="check_sticky poll">
        <input
          type="checkbox"
          className="checkbox_input"
          value={answer.id}
          checked={isSelected}
          id={`answerid_${answer.id}`}
          onChange={(e) => {
            handleChange(e);
          }}
        />
        <label className="label" htmlFor={`answerid_${answer.id}`}></label>
        <span className="an_answer">{answer.answer}</span>
      </div>
    </div>
  );
};

export default Pic;
